<template>
    <div v-if="isValid('CanViewAccountLedger')" v-bind:style="$i18n.locale == 'ar' ? languageChange('en') : languageChange('ar')">
        <div v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <div class="form-group ">
                                <h5 class="card-title DayHeading "> {{ $t('TrialBalanceDetailReport.TrialBalanceDetailReport') }}</h5>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <div class="form-group " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                                <router-link :to="'/AllReports'">
                                    <a href="javascript:void(0)" class="btn btn-outline-primary "><i class="fas fa-arrow-circle-left fa-lg"></i> </a>
                                </router-link>

                                <a href="javascript:void(0)" v-if="isValid('CanPrintAccountLedger')" class="btn btn-outline-primary " v-on:click="PrintDetails">{{ $t('TrialBalanceAccountReport.Print') }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 col-lg-3">
                            <div class="form-group ">
                                <label>{{ $t('TrialBalanceAccountReport.FromDate') }}</label>
                                <datepicker v-model="fromDate" :key="render" />
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3">
                            <div class="form-group ">
                                <label>{{ $t('TrialBalanceAccountReport.ToDate') }}</label>
                                <datepicker v-model="toDate" :key="render" />
                            </div>
                        </div>
                       
                    </div>

                </div>
                <div class="card-body">
                    <table class="table table-striped table-hover table_list_bg">
                        <thead class="">
                            <tr>
                                <th style="width:5%">#</th>

                                <th style="width: 20%; text-align: center">
                                    {{ $t('TrialBalanceDetailReport.Name') }}
                                </th>

                                <th style="width: 20%; text-align: center">
                                    {{ $t('TrialBalanceDetailReport.Name') |arabicLanguage }}
                                </th>
                                <th style="width: 20%; text-align: right">
                                    {{ $t('TrialBalanceDetailReport.Debit') }}
                                </th>
                                <th style="width: 15%; text-align: right">
                                    {{ $t('TrialBalanceDetailReport.Credit') }}
                                </th>
                                <th style="width: 15%; text-align: right">
                                    {{ $t('TrialBalanceDetailReport.Total') }}
                                </th>

                            </tr>
                        </thead>
                    </table>
                    <div v-for="(trans,index) in transactionDetail" v-bind:key="trans.id">

                        <div class="accordion" role="tablist">
                            <b-card no-body class="mb-1">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <table class="table table-striped table-hover table_list_bg" style="margin:0;">
                                        <tbody>
                                            <tr>
                                                <td style="width:5%">
                                                    {{index+1}}
                                                </td>
                                                <td style="width: 20%; text-align: center">
                                                    <strong>
                                                        <a href="javascript:void(0)" v-b-toggle.accordion-1 v-on:click="makeCollapse(trans.name)"> {{trans.name}}</a>
                                                    </strong>

                                                </td>
                                                <td style="width: 20%; text-align: center">
                                                    <strong>
                                                        <a href="javascript:void(0)" v-b-toggle.accordion-1 v-on:click="makeCollapse(trans.name)">   {{trans.nameArabic}}</a>
                                                    </strong>
                                                </td>

                                                <td style="width: 20%; text-align: right">

                                                    {{(parseFloat(trans.debit)).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}

                                                </td>

                                                <td style="width: 15%; text-align: right">
                                                    {{(parseFloat(trans.credit)).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}

                                                </td>
                                                <td style="width: 15%; text-align: right">
                                                    {{trans.total>0?'Dr':'Cr'}} {{nonNegative(trans.total) }}

                                                </td>


                                            </tr>
                                        </tbody>
                                    </table>

                                </b-card-header>
                                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel" v-if="trans.name==collpase">
                                    <b-card-body style="padding-right:0 !important">
                                        <div v-for="(costCenter,busIndex) in trans.costCenterLookUpModel" :key="costCenter.id">
                                            <div class="accordionchild" role="tablist">
                                                <b-card no-body class="mb-1">
                                                    <b-card-header header-tag="header" class="p-1" role="tab">
                                                        <table class="table table-striped table-hover table_list_bg" style="margin:0;">
                                                            <tbody>
                                                                <tr>
                                                                    <td style="width:5%">
                                                                        {{(index + 1) + '.' + (busIndex+1)}}
                                                                    </td>
                                                                    <td style="width: 20%; text-align: center">
                                                                        <strong>
                                                                            <a href="javascript:void(0)" v-b-toggle.accordion-11 v-on:click="makeActiveCollapse(costCenter.accountName)"> {{costCenter.accountName}}</a>
                                                                        </strong>

                                                                    </td>
                                                                    <td style="width: 20%; text-align: center">
                                                                        <strong>
                                                                            <a href="javascript:void(0)" v-b-toggle.accordion-11 v-on:click="makeActiveCollapse(costCenter.accountName)">   {{costCenter.accountNameArabic}}</a>
                                                                        </strong>
                                                                    </td>

                                                                    <td style="width: 20%; text-align: right">
                                                                        {{(parseFloat(costCenter.debit)).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                                    </td>

                                                                    <td style="width: 15%; text-align: right">
                                                                        {{(parseFloat(costCenter.credit)).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}

                                                                    </td>
                                                                    <td style="width: 15%; text-align: right">
                                                                        {{trans.total>0?'Dr':'Cr'}} {{nonNegative(costCenter.total) }}
                                                                    </td>


                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    </b-card-header>
                                                    <b-collapse id="accordion-11" accordion="my-accordionchild" role="tabpanel" v-if="costCenter.accountName==collpaseAccount">
                                                        <b-card-body style="padding-right:0 !important">
                                                            <div v-for="(account,locIndex) in costCenter.trialBalanceModel" :key="account.id">
                                                                <div class="accordionInnerchild" role="tablist">
                                                                    <b-card no-body class="mb-1">
                                                                        <b-card-header header-tag="header" class="p-1" role="tab">
                                                                            <table class="table table-striped table-hover table_list_bg" style="margin:0;">
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td style="width:5%">
                                                                                            {{(index + 1) + '.' + (busIndex+1) + '.' + (locIndex+1)}}
                                                                                        </td>
                                                                                        <td style="width: 20%; text-align: center">
                                                                                            {{account.accountName}}


                                                                                        </td>
                                                                                        <td style="width: 20%; text-align: center">
                                                                                            {{account.accountNameArabic}}
                                                                                        </td>

                                                                                        <td style="width: 20%; text-align: right">
                                                                                            {{(parseFloat(account.debit)).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                                                        </td>

                                                                                        <td style="width: 15%; text-align: right">
                                                                                            {{(parseFloat(account.credit)).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}

                                                                                        </td>
                                                                                        <td style="width: 15%; text-align: right">
                                                                                            {{trans.total>0?'Dr':'Cr'}} {{nonNegative(account.total) }}
                                                                                        </td>


                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>

                                                                        </b-card-header>

                                                                    </b-card>

                                                                </div>
                                                            </div>

                                                        </b-card-body>
                                                    </b-collapse>
                                                </b-card>

                                            </div>
                                        </div>


                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                        </div>

                    </div>
                    <table class="table ">
                       
                            <tr>
                               

                                <th style="width: 45%;  text-align: center" colspan="3">
                                    Total
                                </th>
                            
                                <th style="width: 20%; text-align: right">
                                    {{getDebitTotal}}
                                </th>
                                <th style="width: 15%; text-align: right">
                                    {{getCreditTotal}}
                                </th>
                                <th style="width: 15%; text-align: right">
                                    {{getLineTotal}}
                                </th>

                            </tr>
                        
                    </table>



                </div>
            </div>
        </div>
        <trial-balance-tree-report-print :headerFooter="headerFooter" :printDetails="transactionDetail" :fromDate="fromDate" :toDate="toDate" :formName="formName" :isPrint="isShown" v-if="isShown" v-bind:key="printRender"></trial-balance-tree-report-print>
    </div>
    <div v-else> <acessdenied></acessdenied></div>

</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    import moment from "moment";


    export default {

        mixins: [clickMixin],
        props: ['formNameProp'],
        data: function () {
            return {
                render: 0,
                accountId: '00000000-0000-0000-0000-000000000000',
                fromDate: '',
                toDate: '',
                transactionDetail:[],

                isShown: false,
                formName: 'Account Ledger',
                collpase: '',
                collpaseAccount: '',
                printRender: 0,
                advanceFilters: false,
                combineDate: '',
                dateType: '',
                language: 'Nothing',
                headerFooter: {
                    footerEn: '',
                    footerAr: '',
                    company: ''
                },

            }
        },

       
        watch: {
            fromDate: function (fromDate) {
                this.isShown = false;
                this.fromDate = fromDate;
                this.GetInventoryList(this.fromDate, this.toDate);
                
            },
            toDate: function (toDate) {
                this.isShown = false;

                this.GetInventoryList(this.fromDate, toDate);
            }

        },
        computed: {
            getCreditTotal: function() {
                var sum = 0;
                this.transactionDetail.forEach(function (x) {
                    sum += x.credit;
                })
                return parseFloat(Math.abs(sum)).toFixed(3).slice(0, -1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            },
            getDebitTotal: function() {
                var sum = 0;
                this.transactionDetail.forEach(function (x) {
                    sum += x.debit;
                })
                return parseFloat(Math.abs(sum)).toFixed(3).slice(0, -1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            },
            getLineTotal: function() {
                var sum = 0;
                this.transactionDetail.forEach(function (x) {
                    sum += x.total;
                })
                return parseFloat(Math.abs(sum)).toFixed(3).slice(0, -1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            }
        },

        methods: {
            makeCollapse: function (item) {

                this.collpase = item;
               
            },
            makeActiveCollapse: function (item) {

                this.collpaseAccount = item;
               
            },
            PrintCsv: function () {
                
                var root = this;
                root.$https.post('/Report/TrialBalanceAccountCsv?language=' + this.$i18n.locale + '&fromDate=' + this.fromDate + '&toDate=' + this.toDate + '&companyId=' + localStorage.getItem('CompanyID'), root.transactionDetail, { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }, responseType: 'blob' })
                    .then(function (response) {

                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;


                            link.setAttribute('download', 'AccountLedgerReport.csv');


                        document.body.appendChild(link);
                        link.click();

                    });
            },
            DateTypeSelection: function () {
                this.GetInventoryList(this.fromDate, this.toDate);
            },
            nonNegative: function (value) {
                return parseFloat(Math.abs(value)).toFixed(3).slice(0, -1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            },

            languageChange: function (lan) {
                if (this.language == lan) {

                    var getLocale = this.$i18n.locale;
                    this.language = getLocale;

                    this.$router.go('/FreeofCostSale');

                }
            },

            accountValue: function (x) {

                var accountid = x;
                this.GetInventoryList(this.fromDate, this.toDate, accountid);
            },
            getPage: function () {
                this.GetInventoryList(this.fromDate, this.toDate);
            },
            GetInventoryList: function (fromdate, todate) {
                
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.isShown = false;
                //todate = moment().add(1, 'days').format("DD MMM YYYY")

                this.$https.get('/Report/TrialBalanceTreeReport?fromDate=' + fromdate + '&toDate=' + todate , { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {

                        if (response.data != null) {
                            root.transactionDetail = response.data;
                           
                        }
                    });
            },
            GetHeaderDetail: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get("/Company/GetCompanyDetail?id=" + localStorage.getItem('CompanyID'), { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            root.headerFooter.company = response.data;
                            root.GetInvoicePrintSetting();
                            root.getBase64Image(root.headerFooter.company.logoPath);
                        }
                    });
            },
            GetInvoicePrintSetting: function () {
                var root = this;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Sale/printSettingDetail', { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null && response.data != '') {

                            root.headerFooter.footerEn = response.data.termsInEng;
                            root.headerFooter.footerAr = response.data.termsInAr;
                            root.headerFooter.isHeaderFooter = response.data.isHeaderFooter;
                            root.headerFooter.englishName = response.data.englishName;
                            root.headerFooter.arabicName = response.data.arabicName;
                            root.headerFooter.customerAddress = response.data.customerAddress;
                            root.headerFooter.customerVat = response.data.customerVat;
                            root.headerFooter.customerNumber = response.data.customerNumber;
                            root.headerFooter.cargoName = response.data.cargoName;
                            root.headerFooter.customerTelephone = response.data.customerTelephone;
                            root.headerFooter.itemPieceSize = response.data.itemPieceSize;
                            root.headerFooter.styleNo = response.data.styleNo;
                            root.headerFooter.blindPrint = response.data.blindPrint;
                            root.headerFooter.showBankAccount = response.data.showBankAccount;
                            root.headerFooter.bankAccount1 = response.data.bankAccount1;
                            root.headerFooter.bankAccount2 = response.data.bankAccount2;
                            root.headerFooter.bankIcon1 = response.data.bankIcon1;
                            root.headerFooter.bankIcon2 = response.data.bankIcon2;
                            root.headerFooter.customerNameEn = response.data.customerNameEn;
                            root.headerFooter.customerNameAr = response.data.customerNameAr;

                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });
            },


            PrintDetails: function () {
                var root = this;
                
                root.isShown = true;
                root.combineDate = 'From Date: ' + this.fromDate + ' To Date: ' + this.toDate;
                root.printRender++;
            },


            getBase64Image: function (path) {
                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.headerFooter.company.logoPath = 'data:image/png;base64,' + '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';

                root.$https
                    .get('/Contact/GetBaseImage?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                        if (response.data != null) {
                            root.filePath = response.data;
                            root.headerFooter.company.logoPath = 'data:image/png;base64,' + root.filePath;
                        }
                    });
            },
        },
        created: function () {
            this.GetHeaderDetail();
            this.language = this.$i18n.locale;
            this.fromDate = moment().subtract(15, 'days').format("DD MMM YYYY");
            this.toDate = moment().format("DD MMM YYYY");
        }
    }
</script>
